var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 111,
    viewBox: "0 0 362 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.867432 4.58964C0.867432 2.16332 2.83445 0.196411 5.26079 0.196411H356.729C359.155 0.196411 361.122 2.16332 361.122 4.58964V38.9104C361.122 39.907 360.783 40.8741 360.161 41.6527L358.377 43.8865C353.497 49.9945 353.239 58.5922 357.744 64.9818L360.32 68.6351C360.842 69.3759 361.122 70.2602 361.122 71.1667V105.634C361.122 108.06 359.155 110.027 356.729 110.027H5.26079C2.83445 110.027 0.867432 108.06 0.867432 105.634V71.2365C0.867432 70.2869 1.17519 69.3628 1.74456 68.6027L3.95848 65.6472C8.63653 59.4025 8.63653 50.821 3.95848 44.5762L1.74456 41.6208C1.17519 40.8607 0.867432 39.9365 0.867432 38.9868V4.58964Z",
    fill: "url(#paint0_radial_22_487)",
    fillOpacity: 0.52
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22_487",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.995 -138.007) rotate(90) scale(315.763 947.317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273255"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketBg);
export default __webpack_public_path__ + "static/media/ticket-bg.77fd6552edc9d392d13ce5fa56fd18dd.svg";
export { ForwardRef as ReactComponent };